import { useState } from 'react';
import dayjs from 'dayjs';
import { Upload, Drawer, Input, Spin, Row, Col, TimePicker } from 'antd';
import {
  left_arrow_icon,
  add_icon,
  calender_colored_icon,
} from '../../assets/icons/icons';
import { ThemeButton, ThemeInput, ImageUploader } from '../components';
const { Dragger } = Upload;

const TipDrawer = ({
  open,
  btnTxt,
  addIcon,
  onSubmit,
  isLoading,
  formData,
  setFormData,
  image,
  setImage,
  onClose,
}) => {
  // Check if all required fields are filled
  const isFormValid =
    formData?.image && formData?.title?.trim() && formData?.description?.trim();

  return (
    <Drawer
      width={450}
      title={btnTxt}
      placement="right"
      onClose={onClose}
      open={open}
      closeIcon={<img src={left_arrow_icon} alt="" width={18} height={18} />}
      extra={
        <ThemeButton
          onClick={onSubmit}
          className={'ml-4 w-40'}
          disabled={!isFormValid || isLoading}
          content={
            <>
              {isLoading ? (
                <Spin className="mt-1" />
              ) : (
                <div className="flex items-center">
                  {addIcon && (
                    <img
                      src={add_icon}
                      alt=""
                      width={18}
                      height={18}
                      className="mr-2"
                    />
                  )}
                  <p>{btnTxt}</p>
                </div>
              )}
            </>
          }
        />
      }
    >
      <div className="mb-4">
        <p className="font-semibold mb-2 text-primary">Tips Image</p>
        <ImageUploader
          image={image}
          setImage={e => setImage(e)}
          setFormData={e => setFormData(prev => ({ ...prev, image: e }))}
          enableCrop={true}
          aspectRatio={1}
        />
      </div>
      <Col span={24} className="mb-4">
        <ThemeInput
          label={'Title'}
          labelPrimary
          placeholder={'Tip Title'}
          onChange={e => setFormData({ ...formData, title: e.target.value })}
          value={formData?.title}
          name="title"
        />
      </Col>
      <div className="mb-4">
        <p className="font-semibold mb-1 text-primary">Description</p>
        <Input.TextArea
          name="description"
          placeholder="Tip content"
          rows={5}
          className="font-medium pt-2"
          onChange={e =>
            setFormData({ ...formData, description: e.target.value })
          }
          value={formData?.description}
        />
      </div>
    </Drawer>
  );
};

export default TipDrawer;
